import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { label: "HOME", path: "/" },
  { label: "ABOUT", path: "/about" },
  { label: "PROCESS", path: "/process" },
  { label: "COLLECTIONS", path: "/collections" },
  { label: "EDUCATION", path: "/diamond-education" },
  { label: "REQUEST A DIAMOND", path: "/request-a-diamond" },
  { label: "CONTACT", path: "/contact" },
  { label: "FAQ", path: "/faq" },
];

export default function Navbar() {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-zayan-bg/95 backdrop-blur-sm border-b border-zayan-border"
          : "bg-transparent"
      }`}
    >
      <div className="flex items-center justify-between px-4 lg:px-6 h-[110px] md:h-[150px]">
        {/* Logo */}
        <Link to="/" className="flex flex-col items-center gap-1 shrink-0">
          <span className="font-serif text-lg md:text-xl lg:text-2xl text-zayan-gold tracking-wide">
            Zayan Atelier
          </span>
          <img
            src="https://public.readdy.ai/ai/img_res/9d779e00-88f8-4b7d-bab2-ddc07fc3eeec.png"
            alt="Zayan Atelier"
            className="h-16 md:h-24 w-auto"
          />
        </Link>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-5 lg:gap-8">
          {navLinks.map((link) => {
            const isActive = location.pathname === link.path;
            return (
              <Link
                key={link.path}
                to={link.path}
                className={`text-xs lg:text-[16px] tracking-[0.1em] font-sans transition-colors whitespace-nowrap ${
                  isActive
                    ? "text-zayan-gold border-b border-zayan-gold pb-1"
                    : "text-zayan-textMuted hover:text-zayan-gold"
                }`}
              >
                {link.label}
              </Link>
            );
          })}
        </div>

        {/* CTA Button */}
        <Link
          to="/contact"
          className="hidden md:inline-block border border-zayan-gold text-zayan-gold px-3 py-1.5 text-xs tracking-[0.1em] hover:bg-zayan-gold hover:text-zayan-bg transition-colors whitespace-nowrap"
        >
          SCHEDULE CONSULTATION
        </Link>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden w-10 h-10 flex items-center justify-center text-zayan-gold"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle menu"
        >
          <i className={`ri-${mobileOpen ? "close" : "menu"}-line text-xl`} />
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="md:hidden bg-zayan-bg/98 backdrop-blur-md border-t border-zayan-border px-6 py-6 flex flex-col gap-4">
          {navLinks.map((link) => {
            const isActive = location.pathname === link.path;
            return (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm tracking-[0.15em] py-2 ${
                  isActive ? "text-zayan-gold" : "text-zayan-textMuted"
                }`}
              >
                {link.label}
              </Link>
            );
          })}
          <Link
            to="/contact"
            className="border border-zayan-gold text-zayan-gold px-5 py-3 text-xs tracking-[0.1em] text-center mt-2"
          >
            SCHEDULE CONSULTATION
          </Link>
        </div>
      )}
    </nav>
  );
}